import { render } from "./CreatorKnowledgePointsView.vue?vue&type=template&id=a9deaadc&scoped=true"
import script from "./CreatorKnowledgePointsView.vue?vue&type=script&lang=js"
export * from "./CreatorKnowledgePointsView.vue?vue&type=script&lang=js"

import "./CreatorKnowledgePointsView.vue?vue&type=style&index=0&id=a9deaadc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9deaadc"]])

export default __exports__